import React from 'react'
import { SvgProps } from 'react-native-svg'

import { DSColor, Palette } from '@ppwr/poker'

import Advisor from './Icons/Advisor--enabled.svg'
import AdvisorAvatar from './Icons/advisor-avatar.svg'
import AdvisorAvatarDisabled from './Icons/advisor-avatar-disabled.svg'
import AdvisorDisabled from './Icons/Advisor--disabled.svg'
import Avatar from './Icons/Avatar.svg'
import ArrowDown from './Icons/Arrow---down.svg'
import ArrowLeft from './Icons/Arrow---left.svg'
import ArrowRightWide from './Icons/Arrow---right-wide.svg'
import ArrowRight from './Icons/Arrow---right.svg'
import ArrowBottomRight from './Icons/Arrow--bottom-right.svg'
import ArrowRightEnclosed from './Icons/Arrow--right-enclosed.svg'
import ArrowTopRight from './Icons/Arrow--top-right.svg'
import AssetsChips from './Icons/assets/Chips.svg'
import AssetsStars from './Icons/assets/Stars.svg'
import Audio from './Icons/Audio.svg'
import BadgeBB from './Icons/Badge-BB.svg'
import BadgeD from './Icons/Badge-D.svg'
import BadgeSB from './Icons/Badge-SB.svg'
import BadgeColoredBB from './Icons/BadgeColored-BB.svg'
import BadgeColoredD from './Icons/BadgeColored-D.svg'
import BadgeColoredSB from './Icons/BadgeColored-SB.svg'
import Book from './Icons/Book.svg'
import BrandingIcon from './Icons/BrandingIcon.svg'
import Calendar from './Icons/Calendar.svg'
import CameraFillNone from './Icons/Camera-Fill-None.svg'
import Camera from './Icons/Camera.svg'
import CaretDown from './Icons/CaretDown.svg'
import CheckEnclosed from './Icons/Check--enclosed.svg'
import CheckThick from './Icons/Check--thick.svg'
import Check from './Icons/Check.svg'
import CheckboxUncheck from './Icons/Checkbox-uncheck.svg'
import Checkbox from './Icons/Checkbox.svg'
import ChipFilled from './Icons/Chip--filled.svg'
import Chip from './Icons/Chip.svg'
import ChipOutline from './Icons/Chip-Outline--small.svg'
import ChipsBlueGreen from './Icons/ChipsBlueGreen.svg'
import ChipsOrangePurple from './Icons/ChipsOrangePurple.svg'
import Circle from './Icons/Circle.svg'
import Clock from './Icons/Clock.svg'
import CloseBg from './Icons/Close-bg.svg'
import Copy from './Icons/Copy.svg'
import Edit from './Icons/Edit.svg'
import Dot from './Icons/Dot.svg'
import Flame from './Icons/Flame.svg'
import Globe from './Icons/Globe.svg'
import HamburgerMenu from './Icons/hamburger-menu.svg'
import HoleCards from './Icons/Hole-cards.svg'
import IconsMenu from './Icons/Icons_Menu.svg'
import Info from './Icons/Info.svg'
import InfoFilled from './Icons/Info--filled.svg'
import Key from './Icons/Key.svg'
import Key2 from './Icons/Key2.svg'
import LockLocked from './Icons/Lock--locked.svg'
import One from './Icons/One.svg'
import PauseGame from './Icons/Pause-game.svg'
import PersonFilled from './Icons/Person--filled.svg'
import Person from './Icons/Person.svg'
import Person2 from './Icons/Person2.svg'
import PlayBlack from './Icons/Play--black.svg'
import PlayPokerMenuCreateGame from './Icons/PlayPokerMenuCreateGame.svg'
import PlayPokerMenuJoinGame from './Icons/PlayPokerMenuJoinGame.svg'
import PlayPokerMenuLounges from './Icons/PlayPokerMenuLounges.svg'
import PlayPokerMenuPractice from './Icons/PlayPokerMenuPractice.svg'
import PlusEnclosed from './Icons/Plus--enclosed.svg'
import PokerOrder from './Icons/PokerOrder.svg'
import Quotation from './Icons/Quotation.svg'
import RadioUncheck from './Icons/Radio-uncheck.svg'
import Radio from './Icons/Radio.svg'
import Separator from './Icons/Separator.svg'
import Shell from './Icons/Shell.svg'
import Shield from './Icons/Shield.svg'
import Stars from './Icons/Stars.svg'
import SuiteClub from './Icons/Suite--Club.svg'
import SuiteDiamond from './Icons/Suite--Diamond.svg'
import SuiteHeart from './Icons/Suite--Heart.svg'
import SuiteSpade from './Icons/Suite--Spade.svg'
import SwitchesWhite from './Icons/Switches--white.svg'
import Switches from './Icons/Switches.svg'
import TeachingTableFillNone from './Icons/Teaching-Table-Fill-None.svg'
import Crown from './Icons/Crown.svg'
import TeachingTable from './Icons/Teaching-Table.svg'
import Three from './Icons/Three.svg'
import Trash from './Icons/Trash.svg'
import Turtle from './Icons/Turtle.svg'
import Two from './Icons/Two.svg'
import Union from './Icons/Union.svg'
import WarningEnclosed from './Icons/Warning--enclosed.svg'
import UserIcon from './Icons/UserIcon.svg'
import CloseIcon from './Icons/X.svg'
import YinYang from './Icons/Yin-yang.svg'
import Mic from './Icons/Mic.svg'
import MicOff from './Icons/MicOff.svg'
import Minus from './Icons/Minus--enclosed.svg'
import MinusSmall from './Icons/Minus--small.svg'
import PlusSmall from './Icons/Plus--small.svg'
import Settings from './Icons/Settings.svg'
import SettingsGear from './Icons/SettingsGear.svg'
import SettingsGearColor from './Icons/SettingsGearColor.svg'
import AddChips from './Icons/add-chips.svg'
import Club from './Icons/Club.svg'
import Spade from './Icons/Spade.svg'
import QRCode from './Icons/QR_code.svg'
import RotateLeft from './Icons/Rotate_left.svg'

const Icons = {
  'Assets/Chips': AssetsChips,
  'Assets/Stars': AssetsStars,
  'Arrow---right': ArrowRight,
  'Arrow---left': ArrowLeft,
  'Arrow---down': ArrowDown,
  'Arrow--top-right': ArrowTopRight,
  'Arrow--bottom-right': ArrowBottomRight,
  'Arrow--right-enclosed': ArrowRightEnclosed,
  'Arrow--right-wide': ArrowRightWide,
  'Check--enclosed': CheckEnclosed,
  'Person--filled': PersonFilled,
  'Chips-blue-green': ChipsBlueGreen,
  'Chips-orange-purple': ChipsOrangePurple,
  'Plus--enclosed': PlusEnclosed,
  'Warning--enclosed': WarningEnclosed,
  AddChips,
  Advisor,
  'Advisor-avatar': AdvisorAvatar,
  'Advisor-avatar-disabled': AdvisorAvatarDisabled,
  'Advisor-disabled': AdvisorDisabled,
  Avatar,
  Book,
  Globe,
  Dot,
  Radio,
  'Radio-uncheck': RadioUncheck,
  Checkbox,
  'Checkbox-uncheck': CheckboxUncheck,
  Close: CloseIcon,
  'Close-bg': CloseBg,
  Chip,
  Person,
  Person2,
  Check,
  Info,
  'Info--filled': InfoFilled,
  'Badge--D': BadgeD,
  'Badge--BB': BadgeBB,
  'Badge--SB': BadgeSB,
  'BadgeColored--D': BadgeColoredD,
  'BadgeColored--BB': BadgeColoredBB,
  'BadgeColored--SB': BadgeColoredSB,
  'Suite--Club': SuiteClub,
  'Suite--Diamond': SuiteDiamond,
  'Suite--Heart': SuiteHeart,
  'Suite--Spade': SuiteSpade,
  PauseGame,
  Audio,
  Mic,
  MicOff,
  Camera,
  'Camera-Fill-None': CameraFillNone,
  One,
  Spade,
  TeachingTable,
  'Teaching-Table-Fill-None': TeachingTableFillNone,
  Two,
  Three,
  Switches,
  'Switches-white': SwitchesWhite,
  Clock,
  Calendar,
  Union,
  HoleCards,
  IconsMenu,
  Copy,
  Edit,
  UserIcon,
  Key,
  Key2,
  ChipFilled,
  ChipOutline,
  Flame,
  Shell,
  Shield,
  Turtle,
  YinYang,
  Stars,
  CaretDown,
  Quotation,
  CheckThick,
  Circle,
  'Play--black': PlayBlack,
  PokerOrder,
  HamburgerMenu,
  Separator,
  'Lock-Locked': LockLocked,
  Crown,
  Trash,
  'Minus--enclosed': Minus,
  'Plus--small': PlusSmall,
  'Minus--small': MinusSmall,
  Settings,
  Club,
  QR_code: QRCode,
  Rotate_left: RotateLeft,
  Settings_Gear: SettingsGear,
  Settings_Gear_Color: SettingsGearColor,
  Branding_Icon: BrandingIcon,
  PlayPokerMenuCreateGame,
  PlayPokerMenuJoinGame,
  PlayPokerMenuLounges,
  PlayPokerMenuPractice
} as const

export type DSIcon = keyof typeof Icons

export interface IconsProps extends SvgProps {
  name: DSIcon
  /**
   * [height, width] or single value for both
   */
  size?: number | [number, number] | string | [string, string]
  color?: DSColor | SvgProps['color']
}

export const Icon: React.FC<IconsProps> = ({ name, color, size, ...props }) => {
  const IconComp = Icons[name]
  const [height, width] = Array.isArray(size) ? size : [size, size]
  if (!IconComp) {
    return null
  }

  // @ts-ignore
  const _color = (color && Palette[color]) || color

  return <IconComp color={_color} height={height} width={width} {...props} />
}
